import { InjectionToken } from '@angular/core';

import type { IStorageService } from './storage.model';

export const StorageService = new InjectionToken<IStorageService>('STORAGE_SERVICE');
